module.exports = __webpack_public_path__ + "img/robinson.8eeff38f.svg";